import './office-locator.scss'
import Swiper, { FreeMode, Mousewheel } from 'swiper'

const mapStyle = [
  {
    featureType: 'all',
    elementType: 'geometry',
    stylers: [
      {
        color: '#202c3e',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        gamma: 0.01,
      },
      {
        lightness: 20,
      },
      {
        weight: '1.39',
      },
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        weight: '0.96',
      },
      {
        saturation: '9',
      },
      {
        visibility: 'on',
      },
      {
        color: '#000000',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 30,
      },
      {
        saturation: '9',
      },
      {
        color: '#29446b',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        saturation: 20,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 20,
      },
      {
        saturation: -20,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 10,
      },
      {
        saturation: -30,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#193a55',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        saturation: 25,
      },
      {
        lightness: 25,
      },
      {
        weight: '0.01',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        lightness: -20,
      },
    ],
  },
]

let swiper

function initMap() {
  const markers = []
  const bounds = new google.maps.LatLngBounds()

  const elements = Array.from(document.querySelectorAll('[data-office-entity]') || [])

  const svgMarker = {
    path: 'M3.36952 3.67445C5.12828 1.91568 7.51282 0.926312 10.0001 0.92334C12.4873 0.926312 14.8719 1.91568 16.6306 3.67445C18.3895 5.43335 19.3789 7.81812 19.3817 10.3056C19.3815 14.3587 17.2241 17.9564 14.962 20.6075C12.7318 23.2212 10.4542 24.8512 10.2348 25.0064C10.1649 25.0516 10.0834 25.0757 10.0001 25.0757C9.91674 25.0757 9.83523 25.0516 9.76535 25.0064C9.54599 24.8512 7.26837 23.2212 5.03816 20.6075C2.77604 17.9563 0.618507 14.3586 0.618408 10.3053C0.621305 7.81794 1.61069 5.43328 3.36952 3.67445ZM12.2742 6.90153C11.6011 6.45174 10.8097 6.21167 10.0001 6.21167C8.91446 6.21167 7.8733 6.64293 7.10565 7.41058C6.338 8.17823 5.90674 9.21939 5.90674 10.305C5.90674 11.1146 6.14681 11.906 6.59659 12.5791C7.04638 13.2523 7.68567 13.7769 8.43363 14.0868C9.18159 14.3966 10.0046 14.4776 10.7986 14.3197C11.5927 14.1617 12.322 13.7719 12.8945 13.1994C13.467 12.627 13.8568 11.8976 14.0148 11.1036C14.1727 10.3095 14.0916 9.48652 13.7818 8.73856C13.472 7.9906 12.9474 7.35131 12.2742 6.90153Z',
    fillColor: '#c4fc73',
    fillOpacity: 1,
    strokeColor: '#c4fc73',
    anchor: new google.maps.Point(10, 26),
  }

  elements.map((element, index) => {
    element.addEventListener('click', (e) => {
      google.maps.event.trigger(markers[index], 'click')
    })
  })

  const data = offices.map((office) => ({
    ...office,
    coordinates: new window.google.maps.LatLng(...office.coordinates.replace(' ', '').split(',')),
  }))

  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 4,
    minZoom: 4,
    maxZoom: 12,
    center: data[0].coordinates,
    gestureHandling: 'cooperative',
    disableDefaultUI: true,
    zoomControl: true,
    scrollwheel: false,
  })

  map.setOptions({ styles: mapStyle })

  data.map((office, index) => {
    const marker = new window.google.maps.Marker({
      position: office.coordinates,
      animation: google.maps.Animation.DROP,
      title: office.name,
      icon: svgMarker,
      map,
    })

    markers.push(marker)
    bounds.extend(marker.position)

    window.google.maps.event.addListener(
      marker,
      'click',
      (function (marker, index) {
        return function () {
          const isActive = elements[index].classList.contains('active')

          markers.map((marker) => marker.setAnimation(null))
          elements.map((element) => element.classList.remove('active'))

          if (isActive) return map.fitBounds(bounds)

          swiper?.slideTo(index)
          elements[index].classList.add('active')
          marker.setAnimation(google.maps.Animation.BOUNCE)
          map.panTo(marker.position)
          map.setZoom(10)
        }
      })(marker, index)
    )
  })

  map.fitBounds(bounds)
}

window.initMap = initMap

const initOfficeLocatorSwiper = () => {
  swiper = new Swiper('.office-locator__entities-swiper.swiper', {
    modules: [Mousewheel, FreeMode],

    enabled: false,
    autoHeight: 'true',
    direction: 'vertical',
    slidesPerView: 'auto',
    mousewheel: true,
    freeMode: true,

    breakpoints: {
      768: {
        enabled: true,
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initOfficeLocatorSwiper()
})
